export const mutations = {
  MutationSetIsLoadingStatus(state, loadingStatus) {
    state.isLoadingStatus = loadingStatus;
  },
};
